export const PC_COOKIE_ACCEPTED_VALUE = 'accept';
export const PC_COOKIE_PREFIX = 'cookies-';
export const PC_COOKIE_BAR_HIDDEN_KEY = 'cookie-bar-hidden';

export const PC_COOKIE_TYPES = ['statistics'] as const;

export type PcCookieType = typeof PC_COOKIE_TYPES[number];

export type PcAcceptedCookies = { [key in PcCookieType]: boolean };
